import { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getCurrentUserService,
  updateCurrentUserService,
} from "../api/services";
import { useToast } from "../components/Toast";
import { useRequestError } from "../hooks/useRequestError";

export const EditProfilePage = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { handleRequestError } = useRequestError();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    getCurrentUserService()
      .then((user) => {
        setFirstName(user.first_name || "");
        setLastName(user.last_name || "");
        setPhone(user.phone_number || "");
      })
      .catch(handleRequestError);
  }, [handleRequestError]);

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    try {
      await updateCurrentUserService({
        first_name: firstName.trim(),
        last_name: lastName.trim(),
        phone_number: phone.trim() || null,
      });
      showToast({
        type: "success",
        title: "Saved",
        message: "Profile updated.",
      });
      navigate("/profile");
    } catch (error) {
      handleRequestError(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="page narrow">
      <header className="page-header">
        <h1>Edit profile</h1>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
      </header>
      <form className="panel stack gap-md" onSubmit={onSubmit}>
        <label className="field">
          <span>First name</span>
          <input
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </label>
        <label className="field">
          <span>Last name</span>
          <input
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </label>
        <label className="field">
          <span>Phone</span>
          <input value={phone} onChange={(e) => setPhone(e.target.value)} />
        </label>
        <button type="submit" className="btn btn-primary" disabled={submitting}>
          {submitting ? "Saving…" : "Save"}
        </button>
      </form>
    </div>
  );
};
